import React from "react";
import { useTip } from "../ui/Tooltip/Tooltip";
import { CHART_COLORS } from "../../styles/theme";

/** Jauge semi-circulaire (0 → 100 %) */
const Gauge = ({
    pct = 0,
    color = CHART_COLORS.violet,
    size = 118,
    tip: tipText,
}) => {
    const tip = useTip();
    const r = 42;
    const C = Math.PI * r;
    const val = (Math.min(100, Math.max(0, pct)) / 100) * C;
    const arc = "M13 55 A42 42 0 0 1 97 55";

    return (
        <svg viewBox="0 0 110 62" width={size} height={size * 0.56}>
            <path
                d={arc}
                fill="none"
                stroke={CHART_COLORS.line}
                strokeWidth="11"
                strokeLinecap="round"
            />
            <path
                d={arc}
                fill="none"
                stroke={color}
                strokeWidth="11"
                strokeLinecap="round"
                strokeDasharray={`${val} ${C}`}
                {...tip(tipText)}
            />
        </svg>
    );
};

export default Gauge;
